export const btnPositive = "Yes";
export const btnNegative = "Cancel";

export const lblConfirm = "Are you sure?";
export const lblConfirmDelete = "Yes, Delete it!";
export const lblConfirmDeleteWarning = "You won't be able to revert this!";